import { blue, grey } from '@mui/material/colors';
import { createTheme } from '@mui/material/styles';

export const materialTheme = createTheme({
  palette: {
    primary: {
      main: grey[800],
    },
    secondary: blue,
  },
  components: {
    MuiTableCell: {
      styleOverrides: {
        sizeSmall: {
          padding: 6,
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          border: '1px solid #00000011',
          borderRadius: 14,
        },
        sizeMedium: {
          borderRadius: 10,
        },
        sizeSmall: {
          borderRadius: 8,
        },
      },
    },
  },
});

export const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    background: {
      default: grey[900],
      paper: grey[900],
    },
    primary: {
      main: grey[100],
    },
    secondary: blue,
  },
  components: {
    MuiDialog: {
      styleOverrides: {
        paper: {
          backgroundColor: '#2c2c2c',
          backgroundImage: 'none',
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paperAnchorRight: {
          backgroundColor: grey[900],
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          border: '1px solid #ffffff33',
          borderRadius: 14,
        },
        sizeMedium: {
          borderRadius: 10,
        },
        sizeSmall: {
          borderRadius: 8,
        },
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          color: 'aqua',
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        sizeSmall: {
          padding: 6,
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          '&::-webkit-calendar-picker-indicator': {
            filter: 'invert(1)',
          },
        },
      },
    },
    MuiToolbar: {
      styleOverrides: {
        root: {
          borderTopLeftRadius: 5,
          borderTopRightRadius: 5,
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          background: grey[900],
        },
        arrow: {
          color: grey[900],
        },
      },
    },
  },
});

export const uicolors = {
  black: {
    '50': '#fafafa',
    '100': '#f4f5f5',
    '200': '#e3e5e8',
    '300': '#d3d6d9',
    '400': '#9fa6ac',
    '500': '#6f767c',
    '600': '#50575d',
    '700': '#3e4347',
    '800': '#26292b',
    '900': '#17191b',
    '950': '#090a0b',
  },
  blue: {
    '50': '#eef9ff',
    '100': '#dcf2ff',
    '200': '#b2e8ff',
    '300': '#6dd6ff',
    '400': '#20c3ff',
    '500': '#00baff',
    '600': '#009cdf',
    '700': '#007bb4',
    '800': '#006694',
    '900': '#00527a',
    '950': '#003451',
  },
  green: {
    '50': '#e9fff4',
    '100': '#cbffe4',
    '200': '#9bffd0',
    '300': '#5bfaba',
    '400': '#12d88e',
    '500': '#00d48c',
    '600': '#00ad76',
    '700': '#008a62',
    '800': '#006d4d',
    '900': '#005941',
    '950': '#003326',
  },
  red: {
    '50': '#fff1f3',
    '100': '#ffdfe4',
    '200': '#ffc5ce',
    '300': '#ff9dad',
    '400': '#ff657e',
    '500': '#ff3455',
    '600': '#ed1538',
    '700': '#ce0e2d',
    '800': '#a50f27',
    '900': '#881427',
    '950': '#4a0510',
  },
  yellow: {
    '50': '#fdf9e9',
    '100': '#fbf1c6',
    '200': '#f8e190',
    '300': '#f4c950',
    '400': '#efb021',
    '500': '#df9813',
    '600': '#c0740e',
    '700': '#9a520e',
    '800': '#7f4114',
    '900': '#6c3617',
    '950': '#3f1b09',
  },
};
